import { z } from 'zod';

import { DASHBOARD_PERIODS } from './dashboard.constants';

/**
 * The dashboard's URL state (HS-1501): which scope it looks at and over which period.
 *
 * Every field is optional and falls back through `.catch()`, so a stale bookmark or a hand-edited
 * query never throws — a malformed id reads as "All", a malformed period as the default. Every
 * existing `to: '/dashboard'` link stays valid without naming a search.
 */
export const dashboardSearchSchema = z.object({
  // `guid`, not `uuid`: .NET ids are 8-4-4-4-12 hex but do not promise RFC 4122 variant bits.
  institutionId: z.guid().optional().catch(undefined),
  labId: z.guid().optional().catch(undefined),
  period: z.literal(DASHBOARD_PERIODS).optional().catch(undefined),
});

export type DashboardSearch = z.infer<typeof dashboardSearchSchema>;
